var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignatureEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 2.6665H2.66634C1.93301 2.6665 1.33967 3.2665 1.33967 3.99984L1.33301 11.9998C1.33301 12.7332 1.93301 13.3332 2.66634 13.3332H13.333C14.0663 13.3332 14.6663 12.7332 14.6663 11.9998V3.99984C14.6663 3.2665 14.0663 2.6665 13.333 2.6665ZM13.333 5.33317L7.99967 8.6665L2.66634 5.33317V3.99984L7.99967 7.33317L13.333 3.99984V5.33317Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignatureEmail);
export default __webpack_public_path__ + "static/media/signature-email.394f160dca26569ee207a1596aa76210.svg";
export { ForwardRef as ReactComponent };